import React, { memo } from 'react';
import Svg, { Path, Ellipse } from 'react-native-svg';

export const IconCrownDisable = memo(
  ({ size = 24, color = '#d8d8d8', ...rest }) => {
    return (
      <Svg width={size} height={24} viewBox="0 0 511.925 511.925" {...rest}>
        <Path
          d="M469.333 127.962c-23.564 0-42.667 19.103-42.667 42.667a42.207 42.207 0 002.133 13.163l-34.603 21.995c-22.783 14.516-52.821 9.705-69.931-11.2l-33.92-41.493a42.177 42.177 0 008.32-25.131c0-23.564-19.103-42.667-42.667-42.667s-42.667 19.103-42.667 42.667a42.177 42.177 0 008.32 25.131l-33.92 41.493c-17.107 20.893-47.131 25.703-69.909 11.2L83.2 183.792a42.148 42.148 0 002.133-13.163c.004-23.564-19.095-42.67-42.66-42.674C19.11 127.951.004 147.051 0 170.615c-.004 22.12 16.898 40.575 38.933 42.51l25.216 151.253a10.666 10.666 0 0010.517 8.917h362.667a10.666 10.666 0 0010.517-8.917l25.216-151.253c23.47-2.105 40.79-22.838 38.685-46.308-1.97-21.969-20.361-38.814-42.418-38.855z"
          fill={color}
        />
        <Ellipse cx={256} cy={362.629} rx={181.333} ry={53.333} fill={color} />
        <Path
          d="M256 426.629c-95.424 0-192-21.973-192-64s96.576-64 192-64 192 21.973 192 64-96.576 64-192 64zm0-106.667c-112.043 0-170.667 27.733-170.667 42.667S143.957 405.296 256 405.296s170.667-27.733 170.667-42.667S368.043 319.962 256 319.962z"
          fill={color}
        />
      </Svg>
    );
  }
);
